<section
  class="version-attribute-search"
  [class.version-attribute-search--compact]="compact"
  [class.version-attribute-search--association]="isAssociationLayout"
  [class.version-attribute-search--versions-list]="isVersionsListLayout">
  <header class="version-attribute-search__header" *ngIf="!isAssociationLayout && !isVersionsListLayout">
    <h3 class="version-attribute-search__title">Filter Versions by Inherited Store Attributes</h3>
    <p class="version-attribute-search__subtitle" *ngIf="totalVersionCount">
      {{ totalVersionCount }} version{{ totalVersionCount === 1 ? '' : 's' }} in division
    </p>
  </header>

  <p class="categories-loading" *ngIf="categoriesLoading">
    Loading store attribute filters...
  </p>

  <p class="categories-load-error" *ngIf="!categoriesLoading && categoriesLoadError">
    Could not load store attribute filters. Please refresh and try again.
  </p>

  <ng-container *ngIf="!categoriesLoading && !categoriesLoadError && categories.length; else noFilterAttributes">
    <!-- Versions-list layout (mockup style) -->
    <ng-container *ngIf="isVersionsListLayout; else defaultFilterLayout">
      <div class="filter-panel" [formGroup]="filterForm">
        <h4 class="filter-panel__title">&#128269; Filter Versions by Inherited Store Attributes</h4>

        <div *ngFor="let category of categories" class="filter-section">
          <div class="filter-section-label">
            <span class="dot" [ngClass]="getCategoryDotClass(category.color)"></span>
            {{ category.name }}
          </div>

          <div *ngIf="categoryUsesOnlySelects(category)" class="filter-row">
            <div *ngFor="let field of category.fields" class="filter-group">
              <label>{{ getFilterFieldDisplayName(field) }}</label>
              <select [formControl]="getControl(field.clientKey)">
                <option [ngValue]="null">All {{ getFilterFieldDisplayName(field) }}</option>
                <option *ngFor="let option of getSelectOptions(field)" [ngValue]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>

          <div *ngIf="categoryUsesOnlyMultiSelects(category)" class="filter-row">
            <div *ngFor="let field of category.fields" class="filter-group">
              <label>{{ getFilterFieldDisplayName(field) }}</label>
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="attr-field">
                <mat-select [formControl]="getControl(field.clientKey)" multiple>
                  <mat-option *ngFor="let option of field.options" [value]="option">
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="!categoryUsesOnlySelects(category) && !categoryUsesOnlyMultiSelects(category) && categoryUsesOnlyBooleans(category)" class="filter-checkboxes">
            <label *ngFor="let field of category.fields" class="filter-check">
              <input type="checkbox" [formControl]="getControl(field.clientKey)" />
              {{ field.name }}
            </label>
          </div>

          <div *ngIf="!categoryUsesOnlySelects(category) && !categoryUsesOnlyMultiSelects(category) && !categoryUsesOnlyBooleans(category)" class="filter-row filter-row--mixed">
            <ng-container *ngFor="let field of category.fields">
              <div *ngIf="field.valueType === singleSelectType" class="filter-group">
                <label>{{ getFilterFieldDisplayName(field) }}</label>
                <select [formControl]="getControl(field.clientKey)">
                  <option [ngValue]="null">All {{ getFilterFieldDisplayName(field) }}</option>
                  <option *ngFor="let option of getSelectOptions(field)" [ngValue]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
              <div *ngIf="field.valueType === multiSelectType" class="filter-group">
                <label>{{ getFilterFieldDisplayName(field) }}</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="attr-field">
                  <mat-select [formControl]="getControl(field.clientKey)" multiple>
                    <mat-option *ngFor="let option of field.options" [value]="option">
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <label *ngIf="field.valueType === booleanType" class="filter-check">
                <input type="checkbox" [formControl]="getControl(field.clientKey)" />
                {{ field.name }}
              </label>
              <div *ngIf="field.valueType === textType" class="filter-group">
                <label>{{ getFilterFieldDisplayName(field) }}</label>
                <input type="text" [formControl]="getControl(field.clientKey)" />
              </div>
            </ng-container>
          </div>
        </div>

        <div class="filter-active-tags">
          <span class="filter-results-count" *ngIf="hasAppliedFilters">
            Showing {{ searchSummary.matchingVersions }} of {{ totalVersionCount || searchSummary.matchingVersions }} versions
          </span>
          <span class="filter-results-count" *ngIf="!hasAppliedFilters && hasActiveFilters">
            {{ activeSelections.length }} filter{{ activeSelections.length === 1 ? '' : 's' }} selected
          </span>
          <span class="filter-results-count" *ngIf="!hasActiveFilters">
            Select filters above, then click Filter
          </span>
          <span class="filter-active-tags__sep" *ngIf="hasActiveFilters">|</span>
          <span
            *ngFor="let selection of activeSelections"
            class="filter-tag-removable"
            [ngClass]="getCategoryTagClass(selection.categoryColor)">
            {{ selection.label }}: {{ selection.displayValue }}
            <span class="x" (click)="removeFilter(selection.clientKey)">x</span>
          </span>
          <button type="button" class="btn btn-sm btn-primary filter-btn" [disabled]="!hasActiveFilters" (click)="applyFilters()">
            Filter
          </button>
          <button type="button" class="btn btn-sm btn-outline clear-all-btn-vl" (click)="clearAll()">
            Clear All
          </button>
        </div>
      </div>

      <div class="stats-row" *ngIf="hasAppliedFilters">
        <div class="stat-card">
          <div class="stat-value">{{ searchSummary.matchingVersions }}</div>
          <div class="stat-label">Matching Versions</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ searchSummary.fullMatch }}</div>
          <div class="stat-label">Full Match</div>
        </div>
        <div class="stat-card">
          <div class="stat-value stat-value--warning">{{ searchSummary.partialMatch }}</div>
          <div class="stat-label">Partial Match</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ searchSummary.totalStores }}</div>
          <div class="stat-label">Total Stores</div>
        </div>
      </div>

      <div class="card results-card" *ngIf="hasAppliedFilters">
        <div class="card-header">
          <span>{{ filteredResultsTitle }}</span>
          <span class="card-header__sort">Sorted: full matches first</span>
        </div>

        <p class="results-loading" *ngIf="attributeSearchLoading">Loading matching versions...</p>

        <ng-container *ngIf="!attributeSearchLoading">
          <p class="no-results-message" *ngIf="apiResults.length === 0">
            No versions match the selected filters.
          </p>

          <div *ngFor="let result of fullMatchResults" class="version-item">
            <div class="conflict-icon conflict-ok" [matTooltip]="getMatchTooltip(result)" matTooltipPosition="above">
              &#10003;
            </div>
            <div class="version-code">{{ result.versionName }}</div>
            <div class="version-tags">
              <span
                *ngFor="let tag of result.inheritedAttributes"
                class="tag"
                [ngClass]="getTagClass(tag.categoryColorHex)">
                {{ formatTagLabel(tag) }}
              </span>
            </div>
            <div class="version-meta">
              {{ result.storeCount }} stores<br />
              <span class="version-meta__match version-meta__match--full">{{ result.matchPercent }}% match</span>
            </div>
          </div>

          <div class="partial-matches-banner" *ngIf="partialMatchResults.length">
            &#9888; Partial Matches - cross-state or mixed-capability versions (review before selecting)
          </div>

          <ng-container *ngFor="let result of partialMatchResults">
            <div class="version-item version-item--partial">
              <!-- <div class="version-checkbox"></div> -->
              <div
                class="conflict-icon conflict-warn conflict-warn--clickable"
                [matTooltip]="getMatchTooltip(result)"
                matTooltipPosition="above"
                (click)="toggleConflictDetail(result, $event)">
                !
              </div>
              <div class="version-code">{{ result.versionName }}</div>
              <div class="version-tags">
                <span
                  *ngFor="let tag of result.inheritedAttributes"
                  class="tag"
                  [ngClass]="getTagClass(tag.categoryColorHex)">
                  {{ formatTagLabel(tag) }}
                </span>
              </div>
              <div class="version-meta">
                {{ result.storeCount }} stores<br />
                <span class="version-meta__match version-meta__match--partial">{{ result.matchPercent }}% match</span>
              </div>
            </div>

            <app-version-conflict-detail-panel
              *ngIf="isConflictDetailExpanded(result) && eventId"
              [eventId]="eventId"
              [versionId]="result.versionId!"
              [versionName]="result.versionName"
              [appliedFilters]="appliedSelections"
              [filterPairs]="appliedFilterPairs"
              [showActions]="false">
            </app-version-conflict-detail-panel>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #defaultFilterLayout>
    <div [class.filter-panel-card]="isAssociationLayout">
      <header class="version-attribute-search__header" *ngIf="isAssociationLayout">
        <h3 class="version-attribute-search__title">Filter by Inherited Store Attributes</h3>
      </header>

      <div class="version-attribute-search__panel" [formGroup]="filterForm">
        <div
          *ngFor="let category of categories"
          class="category-block"
          [class.category-block--boolean]="isAssociationLayout && categoryUsesOnlyBooleans(category)">
          <div class="category-header" [style.--cat-color]="category.colorHex">
            <span class="category-dot"></span>
            <span
              class="category-name"
              [style.color]="isAssociationLayout ? category.colorHex : null">
              {{ category.name | uppercase }}
            </span>
          </div>

          <div
            class="filter-grid"
            [class.filter-grid--association]="isAssociationLayout"
            [class.filter-grid--association-select]="isAssociationLayout && !categoryUsesOnlyBooleans(category)"
            [class.filter-grid--boolean]="isAssociationLayout && categoryUsesOnlyBooleans(category)">
            <ng-container *ngFor="let field of category.fields">
              <div class="filter-cell" [ngSwitch]="field.valueType">
                <mat-checkbox
                  *ngSwitchCase="booleanType"
                  [formControl]="getControl(field.clientKey)">
                  {{ field.name }}
                </mat-checkbox>

                <ng-container *ngSwitchCase="textType">
                  <div *ngIf="isAssociationLayout; else browseTextField" class="association-field">
                    <label class="association-field__label">{{ getFilterFieldDisplayName(field) }}</label>
                    <mat-form-field appearance="outline" class="filter-field filter-field--association-select">
                      <input matInput type="text" [formControl]="getControl(field.clientKey)" />
                    </mat-form-field>
                  </div>
                  <ng-template #browseTextField>
                    <mat-form-field appearance="outline" class="filter-field">
                      <mat-label>{{ field.name }}</mat-label>
                      <input matInput type="text" [formControl]="getControl(field.clientKey)" />
                    </mat-form-field>
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="singleSelectType">
                  <div *ngIf="isAssociationLayout; else browseSingleSelectField" class="association-field">
                    <label class="association-field__label">{{ getFilterFieldDisplayName(field) }}</label>
                    <mat-form-field appearance="outline" class="filter-field filter-field--association-select">
                      <mat-select
                        [formControl]="getControl(field.clientKey)"
                        [placeholder]="'All ' + getFilterFieldDisplayName(field)">
                        <mat-option [value]="null">All {{ getFilterFieldDisplayName(field) }}</mat-option>
                        <mat-option *ngFor="let option of getSelectOptions(field)" [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <ng-template #browseSingleSelectField>
                    <mat-form-field appearance="outline" class="filter-field">
                      <mat-label>{{ field.name }}</mat-label>
                      <mat-select [formControl]="getControl(field.clientKey)">
                        <mat-option [value]="null">All {{ field.name }}</mat-option>
                        <mat-option *ngFor="let option of getSelectOptions(field)" [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="multiSelectType">
                  <div *ngIf="isAssociationLayout; else browseMultiSelectField" class="association-field">
                    <label class="association-field__label">{{ getFilterFieldDisplayName(field) }}</label>
                    <mat-form-field appearance="outline" class="filter-field filter-field--association-select">
                      <mat-select [formControl]="getControl(field.clientKey)" multiple>
                        <mat-option *ngFor="let option of getSelectOptions(field)" [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <ng-template #browseMultiSelectField>
                    <mat-form-field appearance="outline" class="filter-field">
                      <mat-label>{{ field.name }}</mat-label>
                      <mat-select [formControl]="getControl(field.clientKey)" multiple>
                        <mat-option *ngFor="let option of getSelectOptions(field)" [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="active-filters-bar" [class.active-filters-bar--association]="isAssociationLayout">
      <div class="active-filters-bar__chips" *ngIf="hasActiveFilters">
        <span
          *ngFor="let selection of activeSelections"
          class="filter-chip"
          [style.background]="chipBackground(selection.categoryColor)"
          [style.borderColor]="isAssociationLayout ? null : chipBorder(selection.categoryColor)"
          [style.color]="chipBorder(selection.categoryColor)">
          {{ selection.label }}: {{ selection.displayValue }}
          <button type="button" class="filter-chip__remove" (click)="removeFilter(selection.clientKey)" aria-label="Remove filter">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      </div>

      <div class="active-filters-bar__summary" *ngIf="!isAssociationLayout">
        <span *ngIf="hasActiveFilters">
          Showing {{ searchSummary.matchingVersions }} of {{ totalVersionCount || searchSummary.matchingVersions }} versions
        </span>
        <span *ngIf="!hasActiveFilters">Select filters above to preview matching versions</span>
      </div>

      <div class="active-filters-bar__meta" *ngIf="isAssociationLayout && hasActiveFilters">
        <span class="active-filters-bar__match-count">
          {{ searchSummary.matchingVersions }} versions match
        </span>
        <button
          type="button"
          class="clear-all-btn clear-all-btn--link"
          (click)="clearAll()">
          Clear All
        </button>
      </div>

      <button
        *ngIf="hasActiveFilters && !isAssociationLayout"
        type="button"
        mat-button
        class="clear-all-btn"
        (click)="clearAll()">
        Clear All
      </button>
    </div>

    <div
      class="bulk-select-row"
      [class.bulk-select-row--association]="isAssociationLayout"
      *ngIf="isAssociationLayout && hasActiveFilters">
      <mat-checkbox
        class="bulk-select-row__full"
        [checked]="allFullMatchesSelected"
        [indeterminate]="someFullMatchesSelected"
        (change)="onSelectAllFullMatchesChange($event.checked)">
        <strong>Select all {{ searchSummary.fullMatch }} full matches</strong>
      </mat-checkbox>
      <mat-checkbox
        class="bulk-select-row__partial"
        [checked]="includePartialMatches"
        (change)="onIncludePartialMatchesChange($event.checked)">
        Include {{ searchSummary.partialMatch }} partial matches
      </mat-checkbox>
    </div>

    <ng-container *ngIf="hasActiveFilters">
      <div class="summary-cards" *ngIf="!isAssociationLayout">
        <div class="summary-card">
          <div class="summary-card__value">{{ searchSummary.matchingVersions }}</div>
          <div class="summary-card__label">Matching Versions</div>
        </div>
        <div class="summary-card">
          <div class="summary-card__value">{{ searchSummary.fullMatch }}</div>
          <div class="summary-card__label">Full Match</div>
        </div>
        <div class="summary-card">
          <div class="summary-card__value">{{ searchSummary.partialMatch }}</div>
          <div class="summary-card__label">Partial Match</div>
        </div>
        <div class="summary-card">
          <div class="summary-card__value">{{ searchSummary.totalStores }}</div>
          <div class="summary-card__label">Total Stores</div>
        </div>
      </div>

      <div class="results-section" [class.results-section--association]="isAssociationLayout">
        <div class="results-section__header" *ngIf="!isAssociationLayout">
          <h4 class="results-section__title">{{ filteredResultsTitle }}</h4>
          <span class="results-section__sort">Sorted: full matches first</span>
        </div>

        <p class="results-loading" *ngIf="attributeSearchLoading">Loading matching versions...</p>

        <ng-template #resultRow let-result>
          <div
            class="result-row"
            [class.result-row--association]="isAssociationLayout"
            [class.result-row--selected]="isAssociationLayout && isVersionSelected(result.versionName)"
            [class.result-row--partial]="isAssociationLayout && result.matchType === 'partial'"
            [class.result-row--disabled]="isAssociationLayout && !isRowSelectable(result)">
            <mat-checkbox
              class="result-row__checkbox"
              [checked]="isAssociationLayout && isVersionSelected(result.versionName)"
              [disabled]="!isAssociationLayout || !isRowSelectable(result)"
              (change)="onVersionCheckboxChange(result, $event.checked)">
            </mat-checkbox>
            <span
              *ngIf="isAssociationLayout"
              class="conflict-icon"
              [class.conflict-icon--ok]="result.matchType === 'full'"
              [class.conflict-icon--warn]="result.matchType === 'partial'"
              [matTooltip]="getMatchTooltip(result)"
              matTooltipPosition="above">
              {{ result.matchType === 'full' ? '✓' : '!' }}
            </span>
            <mat-icon
              *ngIf="!isAssociationLayout"
              class="result-row__match-icon"
              [class.result-row__match-icon--full]="result.matchType === 'full'">
              {{ result.matchType === 'full' ? 'check_circle' : 'adjust' }}
            </mat-icon>
            <div class="result-row__content">
              <div class="result-row__name">{{ result.versionName }}</div>
              <div class="result-row__tags">
                <span
                  *ngFor="let tag of result.inheritedAttributes"
                  class="attribute-tag"
                  [class.attribute-tag--association]="isAssociationLayout"
                  [style.background]="tag.categoryColorHex + '1a'"
                  [style.borderColor]="tag.categoryColorHex"
                  [style.color]="tag.categoryColorHex">
                  {{ formatTagLabel(tag) }}
                </span>
              </div>
            </div>
            <div class="result-row__meta">
              <span class="result-row__stores">{{ result.storeCount }} stores</span>
              <span
                class="result-row__match"
                *ngIf="isAssociationLayout && result.matchType === 'partial'"
                [class.result-row__match--partial]="result.matchType === 'partial'">
                {{ result.matchPercent }}% match
              </span>
              <span
                class="result-row__match"
                *ngIf="!isAssociationLayout"
                [class.result-row__match--full]="result.matchType === 'full'">
                {{ result.matchPercent }}% match
              </span>
            </div>
          </div>
        </ng-template>

        <div class="results-list" *ngIf="!attributeSearchLoading">
          <ng-container *ngIf="!isAssociationLayout">
            <ng-container *ngFor="let result of apiResults">
              <ng-container *ngTemplateOutlet="resultRow; context: { $implicit: result }"></ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="isAssociationLayout">
            <ng-container *ngFor="let result of fullMatchResults">
              <ng-container *ngTemplateOutlet="resultRow; context: { $implicit: result }"></ng-container>
            </ng-container>

            <div class="partial-matches-separator" *ngIf="partialMatchResults.length">
              Partial Matches - cross-state or mixed-capability versions
            </div>

            <ng-container *ngFor="let result of partialMatchResults">
              <ng-container *ngTemplateOutlet="resultRow; context: { $implicit: result }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <p class="no-filters-message" *ngIf="isAssociationLayout && !hasActiveFilters">
      Select filters above to find matching versions.
    </p>
    </ng-template>
  </ng-container>

  <ng-template #noFilterAttributes>
    <p class="no-filters-message" *ngIf="!categoriesLoading && !categoriesLoadError">
      No store attributes are enabled for filtering. Enable filters in Store Attribute Types administration.
    </p>
  </ng-template>
</section>
